import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse } from "@api";

import type { IPathBaseParam } from "./path";

const postApis = createPostApi<IApiResponse<unknown>, IPathBaseParam, object>(
  "stores.measurementUnits.deactive",
);

export const deactive = {
  ...postApis,
};
